<template>
  <div class="main_body">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div class="container-fluid">
      <div class="card mt-3 text-white bg-dark">
        <div class="topnav bg-dark">
          <a class="active" href="#">Audio Books</a>
        </div>
        <div class="mt-3">
          <span class="m-3">Audio Book List</span>
          <div class="card-body">
            <div class="table-responsive-sm">
              <table class="custom_table">
                <thead>
                  <tr>
                    <td>Id</td>
                    <td>Name</td>
                    <td>EnName</td>
                    <td>Price</td>
                    <td>Image</td>
                    <td>Author Name</td>

                    <td style="min-width: 150px">Action</td>
                  </tr>
                </thead>
                <tbody v-for="(data, index) in filteredAudioBook" :key="index">
                  <tr>
                    <td>{{ data.id }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.en_name }}</td>
                    <td>{{ data.price }}</td>
                    <td>
                      <img :src="data.thumb_path" height="50px" width="80px" />
                    </td>
                    <td>{{ data.author_name }}</td>

                    <td>
                      <div class="d-flex align-items-center gap-2">
                        <span class="badge text-bg-primary" style="cursor: pointer" data-bs-toggle="modal"
                          data-bs-target="#episodeListModal" @click="setAudioId(data.id)"><i class="fas fa-eye"></i> Episode</span>
                        <span class="badge text-bg-primary" style="cursor: pointer" @click="getAudioData(data.id)" data-bs-toggle="modal"
                          data-bs-target="#UpdateAudioBookModal"><i class="fas fa-sliders"></i></span>

                        <span class="badge bg-info" style="cursor: pointer" v-on:click="viewAudioBook(data.id)">
                          <i class="fas fa-eye"></i> </span>
                        <span class="badge bg-danger" style="cursor: pointer" v-on:click="deleteAudioBook(data.id, 1)">
                          <i class="fas fa-trash-alt"></i> </span>&ensp;
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <update-audio-book-modal
        :audioBookId="audiobook_by_id.id"
        :audioBookImage="audiobook_by_id.thumb_path"
        :audioBookName="audiobook_by_id.name"
        :audioBookEnName="audiobook_by_id.en_name"
        :audioBookAuthor="audiobook_by_id.author_name"
        :audioBookArtist="audiobook_by_id.contributing_artists"
        :audioBookPublisher_id="audiobook_by_id.publisher_id"
        :audioBookCategoryId="audiobook_by_id.category_id"
        :audioBookCategory="audiobook_by_id.c_name" :audioDescription="audiobook_by_id.description"
        :audioBookPrice="audiobook_by_id.price"></update-audio-book-modal>
      <EpisodeListModal :audioBookID="audioBookID"/>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import Mixin from "../../mixin";
import UpdateAudioBookModal from "../publisher/UpdateAudioBookModal.vue";
import EpisodeListModal from "@/pages/publisher/episodeLIstModal";
export default {
  name: "AudioBookList",
  components: {EpisodeListModal, Loading, UpdateAudioBookModal },
  mixins: [Mixin],
  data() {
    return {
      publisherid: localStorage.getItem(this.$publisherId),
      bookData: [],
      adminChannels: [],
      filteredAudioBook: [],
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
      audiobook: [],
      audiobook_by_id:"",
      audioBookID: null
    };
  },
  async created() {
    const token = localStorage.getItem(this.$tokenKey);
    this.adminChannels = await this.getAdminChannels(this.publisherid, token);
    console.log(this.adminChannels);
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/audiobooks/" + this.id,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (res.status == 200) {
          this.audiobook = res.data[0][0];
          console.log("Hello", this.audiobook)
          this.episodes = res.data[4];
          // console.log(this.audiobook, this.episodes);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
      this.isLoading = false;
    },
    async getAudioData(audioBook_id) {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/audiobooks/" + audioBook_id,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (res.status == 200) {
          this.audiobook_by_id = res.data[0][0];
          // console.log("Hello" ,this.audiobook)
          this.episodes = res.data[4];
          // console.log(this.audiobook, this.episodes);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
      this.isLoading = false;
    },
    async getAudioBookData() {
      console.log("this.pendingPage");
      //console.log(this.pendingPage);
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/audiobooks",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          //console.log(res.data);
          let flag = false;
          for (let i = 0; i < res.data.length; i++) {
            //console.log(this.bookData[i].name);
            for (let j = 0; j < this.adminChannels.data.length; j++) {
              // if (
              //   res.data[i].channel_id == this.adminChannels.data[j].id
              // ) {
              //   //console.log(flag)
              //   flag = true;
              //   console.log(flag);
              //   break;
              // } else {
              //   flag = false;
              // }
            }
            if (!flag) {
              this.filteredAudioBook.push(res.data[i]);
              console.log("this.filteredAudioBook");
              console.log(this.filteredAudioBook);
            }
          }
          this.bookData = res.data;
          console.log(this.bookData)
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    setAudioId(id) {
      this.audioBookID = id;
    },
    viewAudioBook(id) {
      this.$router.push("/audiobook/" + id);
    },
    async deleteAudioBook(id, status) {
      alert("Are you sure!!");
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.put(
          this.$baseUrl +
          this.$api +
          this.$version1 +
          "/audiobooks/delete" +
          "?audio_bookId=" +
          id,
          {
            status: status,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        //console.log(res);
        if (res.status == 200) {
          this.$vToastify.info("AudioBook Deleted");
          this.getAudioBookData();
        } else {
          this.$vToastify.error("Something went wrong");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    filterAdminAudioBook() {
      //let flag = false;
      // for (let audioBook in this.bookData) {
      //   console.log(audioBook);
      //   for (adminChannel in this.adminChannels) {
      //     if (audioBook.channel_id == adminChannel.id) {
      //       flag = true;
      //       break;
      //     }
      //   }
      //   if (flag == false) {
      //     this.filteredAudioBook.push(audioBook);
      //     console.log("this.filteredAudioBook");
      //     console.log(this.filteredAudioBook);
      //   }
      // }
    },
  },
  mounted() {
    // use this for get
    //this.filterAudioBook();
    this.getAudioBookData();
    // this.getData();
  },
};
</script>
